import { MonitoringGraphData } from "@services/monitoring/types";

const ONE_DAY = 1e3 * 60 * 60 * 24;

export const getStartTime = (start: number, end: number) =>
  end - start < ONE_DAY ? start : end - ONE_DAY;

export const getStopTime = (end: number) =>
  new Date().getTime() < end ? end : new Date().getTime();

const isYNotNull = (point: [number, number | null]) => point[1] !== null;

export const getSafeChartData = (chartData: MonitoringGraphData[]) => {
  return chartData.map((dataset) => ({
    ...dataset,
    data: (dataset.data ?? []).filter(isYNotNull),
  }));
};
